// Kullanıcıya gösterilen toplantı "derinlik" seçenekleri. Arkadaki gerçek model id'si
// (value) kullanıcıya ASLA gösterilmez; UI yalnızca label'ı gösterir. Backend'deki
// MeetingController.ModelOptions() ile aynı olmalı.
export interface ModelOption { value: string; label: string; description: string; }

export const MODEL_OPTIONS: ModelOption[] = [
  { value: 'claude-opus-4-8',   label: 'Detaylı', description: 'En derin analiz ve muhakeme. Daha yavaş, daha fazla kredi harcar.' },
  { value: 'claude-sonnet-4-6', label: 'Orta',    description: 'Dengeli hız ve derinlik. Çoğu toplantı için önerilir.' },
  { value: 'claude-haiku-4-5',  label: 'Hızlı',   description: 'En hızlı ve en ekonomik. Daha az kredi harcar.' }
];

export const DEFAULT_MODEL = 'claude-sonnet-4-6';

export function modelLabel(id: string): string {
  const o = MODEL_OPTIONS.find(x => x.value === id);
  return o ? o.label : (id || '');
}
